import React, { useState } from 'react';
import { Card, Grid, CardHeader, CardContent, CardActions, IconButton,Chip, Avatar, Typography, CardMedia, Button, Modal, Box, TextField } from '@mui/material';
import { ThumbUp, Bookmark, Share, MoreVert, Comment } from '@mui/icons-material';

export default function Feed() {
    const [openModal, setOpenModal] = useState(false);
    const [openMoreComments, setOpenMoreComments] = useState(false);
    const [reply, setReply] = useState('');
    const [replies, setReplies] = useState([]);

    const feeds = [
        {
            avatar: 'https://via.placeholder.com/40',
            username: '张三',
            subtitle: '前端开发工程师',
            content: '这是一个资讯内容简介，介绍与该职位相关的内容...',
            images: [
                'https://via.placeholder.com/600x300',
                'https://via.placeholder.com/600x300',
                'https://via.placeholder.com/600x300',
                'https://via.placeholder.com/600x300',
                'https://via.placeholder.com/600x300',
            ],
            video: 'https://via.placeholder.com/600x300.mp4', // 视频链接
            postContent: '这是一个技术相关的资讯内容，前端开发技巧和分享。',
            likes: 10,
            bookmarks: 5,
            shares: 3,
            comments: [
                { username: '评论者A', content: '这篇文章非常有帮助！' },
                { username: '评论者B', content: '学到了很多！' },
            ],
        },
        {
            avatar: 'https://via.placeholder.com/40',
            username: '李四',
            subtitle: '后端开发工程师',
            content: '这是另一个资讯内容简介，介绍与该职位相关的内容...',
            images: ['https://via.placeholder.com/600x300'],
            postContent: '分享一下我的日常生活和随笔，记录生活中的点滴。',
            likes: 15,
            bookmarks: 8,
            shares: 5,
            comments: [
                { username: '评论者C', content: '生活随笔很有趣！' },
                { username: '评论者D', content: '喜欢这样的分享。' },
            ],
        },
    ];

    const handleOpenMore = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenMoreComments = () => {
        setOpenMoreComments(true);
    };

    const handleCloseMoreComments = () => {
        setOpenMoreComments(false);
    };

    const handleReplyChange = (event) => {
        setReply(event.target.value);
    };

    const handleReplySubmit = () => {
        if (reply) {
            setReplies([...replies, { username: '你', content: reply }]);
            setReply('');
        }
    };

    return (
        <div style={{ marginBottom: '200px' }}>
            {/* 资讯推荐 */}
            <Typography variant="h6" gutterBottom>
                资讯推荐
            </Typography>


            {/* 热门标签 */}
            <Card>
                <CardContent>
                    <div>
                        <Chip label="全部" sx={{ margin: 0.5 }} />
                        <Chip label="职位" sx={{ margin: 0.5 }} />
                        <Chip label="动态" sx={{ margin: 0.5 }} />
                    </div>
                </CardContent>
            </Card>
            <Grid container spacing={2}>
                {feeds.map((feed, index) => (
                    <Grid item xs={12} key={index}>
                        <Card>
                            <CardHeader
                                avatar={<Avatar src={feed.avatar} />}
                                title={feed.username}
                                subheader={feed.subtitle}
                            />
                            <CardContent>
                                <Typography variant="body1">{feed.postContent}</Typography>

                                {/* 九宫格图片展示 */}
                                <Grid container spacing={1}>
                                    {feed.images.map((img, i) => (
                                        <Grid item xs={4} key={i}>
                                            <CardMedia
                                                component="img"
                                                sx={{ height: 150 }}
                                                image={img}
                                                alt={`资讯图片 ${i + 1}`}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>

                                {/* 视频内容展示 */}
                                {feed.video && (
                                    <CardMedia
                                        component="video"
                                        controls
                                        sx={{ marginTop: 2 }}
                                        src={feed.video}
                                        title="资讯视频"
                                    />
                                )}
                            </CardContent>

                            {/* 操作按钮 */}
                            <CardActions>
                                <IconButton>
                                    <ThumbUp color="error" />
                                    <Typography sx={{ marginLeft: 1 }}>{feed.likes}</Typography>
                                </IconButton>
                                <IconButton>
                                    <Bookmark />
                                    <Typography sx={{ marginLeft: 1 }}>{feed.bookmarks}</Typography>
                                </IconButton>
                                <IconButton>
                                    <Share />
                                    <Typography sx={{ marginLeft: 1 }}>{feed.shares}</Typography>
                                </IconButton>
                                <IconButton onClick={handleOpenMore}>
                                    <MoreVert />
                                </IconButton>
                            </CardActions>

                            {/* 评论展示和回复功能 */}
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    评论
                                </Typography>
                                {feed.comments.map((comment, idx) => (
                                    <Typography key={idx} variant="body2">
                                        {comment.username}: {comment.content}
                                    </Typography>
                                ))}
                                {replies.map((reply, idx) => (
                                    <Typography key={idx} variant="body2">
                                        {reply.username}: {reply.content}
                                    </Typography>
                                ))}
                                <TextField
                                    fullWidth
                                    placeholder="回复..."
                                    value={reply}
                                    onChange={handleReplyChange}
                                    sx={{ marginTop: 2 }}
                                />
                                <Button onClick={handleReplySubmit} sx={{ marginTop: 1 }}>
                                    回复
                                </Button>
                                {/* 更多评论 */}
                                <Button onClick={handleOpenMoreComments} size="small">
                                    更多评论
                                </Button>
                            </CardContent>

                            {/* 更多操作弹出菜单 */}
                            <Modal open={openModal} onClose={handleCloseModal}>
                                <Box
                                    sx={{
                                        padding: 2,
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Button onClick={() => alert('举报成功')}>投诉</Button>
                                    <Button onClick={() => alert('已标记为不喜欢')}>不喜欢</Button>
                                </Box>
                            </Modal>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* 更多评论弹出窗口 */}
            <Modal open={openMoreComments} onClose={handleCloseMoreComments}>
                <Box
                    sx={{
                        padding: 2,
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        textAlign: 'center',
                        width: '80%',
                        margin: 'auto',
                        marginTop: '10%',
                    }}
                >
                    <Typography variant="h6">更多评论</Typography>
                    {feeds[0].comments.map((comment, idx) => (
                        <Typography key={idx} variant="body2">
                            {comment.username}: {comment.content}
                        </Typography>
                    ))}
                </Box>
            </Modal>

            <Card>
                <CardContent>
                    <div style={{textAlign:'center'}}>
                        <Chip label="加载更多" sx={{ margin: 0.5 }} />
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}